import { ColDef } from '@ag-grid-community/core';

export const columnDefs: ColDef[] = [
  { headerName: 'Directory', field: 'directory', lockVisible: true, lockPosition: true },
  { headerName: 'Report Name', field: 'report', lockVisible: true, lockPosition: true },
];

export const defColumnPreferences = [
  { colId: 'directory', hide: false, aggFunc: null, width: 200, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'report', hide: false, aggFunc: null, width: 800, pivotIndex: null, pinned: null, rowGroupIndex: null },
];

export function calculateFields(rowdata: any[]) {
  const reports: any[] = [];

  if (!rowdata) {
    return reports;
  }

  for (const row of rowdata) {
    const data = {
      id: row.id,
      directory: null,
      report: null,
    };

    data.directory = row.id.replace(/\\/g, '/').split('/')[0];

    data.report = row.id
      .replace(/\\/g, '/')
      .replace(`${data.directory}/`, '')
      .replace(/\.rpt/gi, '')
      .replace(/([A-Za-z0-9)])(\()/gi, '$1 $2')
      .replace(/\//gi, ' / ')
      .replace(/_/gi, ' ');

    reports.push(data);
  }

  return reports;
}
